/**
 * 大同自定义事件名
 */
export const CUSTOM_EVENT_NAME = {
  /** 页面切出 */
  pageOut: 'custom_pgout',
  /** 点击上报 */
  click: 'custom_click',
  statusAlterDialogSubmit: 'status_alter_dialog_submit',
  dashboardTitleList: 'dashboard_title_list',
  dashboardTrendVersion: 'dashboard_trend_version',
  dashboardCompareVersion: 'dashboard_compare_version',
};

export const DATONG_EVENT_NAME = {
  click: 'dt_clck',
};

/** 大同上报元素ID */
export const DATONG_PAGE_EID = {
  /** 顶部产品设置按钮 */
  dashboardTopPagesetting: 'dashboard_top_pagesetting',
  /** 顶部退出登陆按钮 */
  dashboardTopLogout: 'dashboard_top_logout',
  /** 顶部我的产品按钮 */
  dashboardTopMyproduct: 'dashboard_top_myproduct',
  /** 顶部常见问题按钮 */
  dashboardTopProblem: 'dashboard_top_problem',
  /** 顶部论坛按钮 */
  dashboardTopForum: 'dashboard_top_forum',
  /** 顶部文档中心按钮 */
  dashboardTopDocument: 'dashboard_top_document',
  /** 顶部SDK按钮 */
  dashboardTopSdk: 'dashboard_top_sdk',
  /** 顶部首页按钮 */
  dashboardTopHome: 'dashboard_top_home',
  /** 异常概览趋势统计维度 */
  dashboardCountDim: 'dashboard_count_dim',
  /** 异常概览趋势指标 */
  dashboardCountQuota: 'dashboard_count_quota',
  /** 异常概览top3状态变更 */
  dashboardTop3Statuschange: 'dashboard_top3_statuschange',
  /** 异常概览top20状态变更 */
  dashboardTop20Statuschange: 'dashboard_top20_statuschange',
  /** 异常概览top3处理人选择 */
  dashboardTop3Processorchange: 'dashboard_top3_processorchange',
  /** 异常概览top20处理人选择 */
  dashboardTop20Processorchange: 'dashboard_top20_processorchange',
  /** 异常概览top20批量转tapd单 */
  dashboardCheckTapd: 'dashboard_check_tapd',
  /** 异常概览对比选项显示按钮*/
  dashboardCompareOptionsShow: 'dashboard_compare_options_show',

  /** 问题列表查询 */
  issueListSearch: 'issue_list_search',
  /** 问题列表批量状态变更 */
  issueListCheckStatus: 'issue_list_check_status',
  /** 问题列表批量转tapd单 */
  issueListCheckTapd: 'issue_list_check_tapd',
  /** 问题列表状态变更 */
  issueListStatus: 'issue_list_status',
  /** 问题列表处理人选择 */
  issueListProcessor: 'issue_list_processor',
  /** 问题列表转tapd单 */
  issueListTapd: 'issue_list_tapd',
  /** 问题列表跳转tapd */
  issueListTapdLink: 'issue_list_tapd_link',
  /** 问题列表table头部导出按钮 */
  issueListExport: 'issue_list_export',
  /** 问题列表备注 */
  issueListRemark: 'issue_list_remark',
  /** 问题列表查看更多 */
  issueListMore: 'issue_list_more',
  /** 问题列表添加标签 */
  issueListTag: 'issue_list_tag',
  /** 展开收起查询 */
  issueListExpandFilters: 'issue_list_expand_filters',
  /** 全选自定义标签 */
  issueListSelectAllCustomFilters: 'issue_list_selectAll_filters',

  /** 上报记录详情分析tab */
  issueDetailAnalyze: 'issue_detail_analyze',
  /** 上报记录问题概览tab */
  issueDetailProblem: 'issue_detail_problem',
  /** 问题详情查询 */
  issueDetailSearch: 'issue_detail_search',
  /** 问题详情状态变更 */
  issueDetailStatuschange: 'issue_detail_statuschange',
  /** 问题详情处理人选择 */
  issueDetailProcessor: 'issue_detail_processor',
  /** 问题详情提tapd单 */
  issueDetailTapd: 'issue_detail_tapd',
  /** 问题详情跳转tapd */
  issueDetailTapdLink: 'issue_detail_tapd_link',
  /** 问题详情手工还原 */
  issueDetailHandmade: 'issue_detail_handmade',
  /** 问题详情列表分页 */
  issueDetailListPagination: 'issue_detail_list_pagination',
  /** 问题详情导出Crash */
  issueDetailExpcrash: 'issue_detail_expcrash',
  /** 问题详情打包extraMessage */
  issueDetailBaleextra: 'issue_detail_baleextra',
  /** 问题详情列表右侧tab */
  issueDetailListTab: 'issue_detail_list_tab',
  /** 问题详情备注提交 */
  issueDetailRemarkSubmit: 'issue_detail_remark_submit',
  /** 问题详情添加标签 */
  issueDetailTag: 'issue_detail_tag',
  /** 问题详情跟踪日志分类按钮 */
  issueDetailTrancelogAssort: 'issue_detail_trancelog_assort',
  /** 问题详情跟踪日志类型按钮 */
  issueDetailTrancelogType: 'issue_detail_trancelog_type',
  /** 题详情跟踪日志查询框 */
  issueDetailTrancelogSearch: 'issue_detail_trancelog_search',
  /** 问题详情跟踪日志IDE复选框 */
  issueDetailTrancelogIde: 'issue_detail_trancelog_ide',
  issueDetailSymbolDownload: 'issue_detail_symbol_download',
  /** 问题详情跟踪数据下载 */
  issueDetailTrancedataDownload: 'issue_detail_trancedata_download',
  /** 问题详情跟踪数据打包下载 */
  issueDetailTrancedataBaledown: 'issue_detail_trancedata_baledown',
};

export const DATONG_ELEMENT_PARAMS = {
  issueListBtnName: 'issueList_btn_name',
  homeTopBtnName: 'homeTop_btn_name',
  issueDetailBtnName: 'issueDetail_btn_name',
  customSearchParams: 'custom_search_params',
};

export const CUSTOM_ACTIONS = {
  commonCopilotClick: 'common_enter_copilot_click',
  commonEnterBuyResourcePackPage: 'common_enter_buy_resource_pack_page',
  commonBuyResourcePack: 'common_buy_resource_pack',
  commonConsultBuyResourcePack: 'common_consult_buy_resource_pack',
  commonPayOrder: 'common_pay_order',
  commonShowPayResult: 'common_show_pay_result',
  commonClickHasPaidOrder: 'common_click_has_paid_order',
  commonClickHasPayProblem: 'common_click_has_pay_problem',
  commonDelOrder: 'common_del_order',
  commonViewOrderDetail: 'common_view_order_detail',
  commonTryPayOrder: 'common_try_pay_order',
  commonEnterOverseas: 'common_enter_overseas', // 海外版导流按钮
  // FOOM关联监控列表链接点击
  foomDetailLinkagesToList: 'foom_detail_linkages_to_list',
  // FOOM关联监控详情链接点击
  foomDetailLinkagesToDetail: 'foom_detail_linkages_to_detail',
  // 多维下钻上报
  commonDimensionStatistics: 'common_dimension_statistics',
  // 统计分布选择指标
  commonTrendChangeStatistics: 'common_trend_change_statistics',
  // 统计分布选择指标
  commonDistributionKeys: 'common_distribution_change_distribution_keys',
  // 统计分布切换维度
  commonDistributionMetricType: 'common_distribution_change_metricType',
  // 概览页面tab
  commonDashboardTab: 'common_dashboard_tab',
  // 详情页复制堆栈
  commonCopyStack: 'common_copy_stack',
  // 详情页搜索堆栈
  commonSearchStack: 'common_search_stack',
  // 详情页堆栈切换展开
  commonCollapsedStack: 'common_collapsed_stack',
  commonViewAttachment: 'common_view_attachment',
  commonCollapseOtherThreadStack: 'common_collapse_other_thread_stack',
  commonExpandOtherThreadStack: 'common_expand_other_thread_stack',
  commonGPT: 'common_gpt',
  commonCreateTapdBug: 'common_create_tapd_bug',
  commonBatchCreateTapdBug: 'common_batch_create_tapd_bug',
  commonJumpTapd: 'common_jump_tapd',
  commonAddIssueTag: 'common_add_issue_tag',
  commonCopyDetailUrl: 'common_copy_detail_url',
  commonViewDetail: 'common_view_detail',
  commonDoSearch: 'common_do_search',
  commonDownloadAttachments: 'common_download_attachments',
  commonEnterContrastMode: 'common_enter_contrast_mode',
  commonEnterIssueAnalysis: 'common_enter_issue_analysis',
  commonEnterIssueSummary: 'common_enter_issue_summary',
  commonSwitchPage: 'common_switch_page',
  commonChangeCollation: 'common_change_collation',
  commonEditSearchCriteria: 'common_edit_search_criteria',
  commonExportCaseInfo: 'common_export_case_info', // 导出个例摘要
  commonExportAttachment: 'common_export_attachment', // 导出附件
  commonExpandTrendAnalysis: 'common_expand_trend_analysis',
  commonCloseTrendAnalysis: 'common_close_trend_analysis',
  commonSwitchToStatistics: 'common_switch_to_statistics',
  commonOpenGcDetail: 'common_open_gc_detail', // 打开 GC 详情tab
  commonGcDetailJumpJavaMemory: 'common_gc_detail_jump_to_java_memory', // GC 详情跳转到 Java 内存
  tableSettingColumnsChange: 'table_setting_columns_change',
  tableSettingVisibleChange: 'table_setting_visible_change',
  quotaAddToCompList: 'quota_add_to_comp_list',
  quotaViewCompList: 'quota_view_comp_list',
  quotaMultiDimensionQuery: 'quota_multi_dimension_query',
  quotaMultiQuery: 'quota_multi_query',
  quotaComplianceQuery: 'quota_compliance_query',
  quotaComplianceToggle: 'quota_compliance_toggle',
  quotaAnrQuery: 'quota_anr_query',
  quotaLagQuery: 'quota_lag_query',
  quotaLagToggle: 'quota_lag_toggle',
  quotaFoomQuery: 'quota_foom_query',
  quotaLaunchQuery: 'quota_launch_query',
  quotaLaunchToggle: 'quota_launch_toggle',
  quotaLaunchSpanQuery: 'quota_launch_span_query',
  quotaMemoryQuery: 'quota_memory_query',
  quotaMemoryToggle: 'quota_memory_toggle',
  quotaSelectTime: 'quota_select_time',
  quotaVersionSelectTime: 'quota_version_select_time',
  quotaVersionChangePubTime: 'quota_version_change_pub_time',
  quotaVersionChangeVersion: 'quota_version_change_version',
  quotaVersionClickOK: 'quota_version_click_ok',
  quotaVersionReset: 'quota_version_reset',
  quotaVersionSetVersion: 'quota_version_set_version',
  issueListQuery: 'issue_list_query',
  IssueListToggle: 'issue_list_toggle',
  issueListLaunchQuery: 'issue_list_launch_query',
  metrickitLogQuery: 'metrickit_log_query',
  functionDetailListComplianceQuery: 'function_detail_list_compliance_query',
  statusAlterDialogSubmit: 'status_alter_dialog_submit', // 处理状态修改
  dashboardTrendVersion: 'dashboard_trend_version', // 概览版本筛选
  dashboardHeadTab: 'dashboard_head_tab', // 概览tab切换
  dashboardCompareVersion: 'dashboard_compare_version', // 概览对比tab切换
  noticeModalView: 'notice_modal_view',
  noticeModalViewDetail: 'notice_modal_view_detail',
  guideUpgradeView: 'guide_upgrade_view',
  guideUpgradeClick: 'guide_upgrade_click',
};
